define((require) => {
    var _                 = require("underscore"),
        $                 = require("jquery"),
        AbstractRulerView = require("ui/editor/ruler/AbstractRulerView");

    /**
     *
     * @param {HTMLElement} el html element container
     * @param {ExperienceModel} model The active experience.
     */
    return AbstractRulerView.extend({

        SPACING_CSS_PROPERTY: "margin-top",

        DISTANCE_CSS_PROPERTY: "top",

        className: "vertical",

        // The mousedown event is not triggered if defined in AbstractRulerView.
        events: {
            "mousedown": "_onMouseDown"
        },

        /**
         * Renders the ruler for a given scene number
         * @param {Number} height
         * @param {Object} renderOptions @see AbstractRulerView#getDefaultRenderOptions
         */
        render: function(height, renderOptions) {
            renderOptions = _.extend(this.getDefaultRenderOptions(), renderOptions);

            var self = this,
                unscaledRulerHeight = height + 1;

            var $ruler = this._createRuler(height, renderOptions.scale);

            $ruler.children("ul").height(unscaledRulerHeight);

            $ruler.find(".ruler-px-value").each((index, incrementTextElement) => {
                var topPx = self._calculateIncrementTextElementTopPx(index, renderOptions.scale);

                $(incrementTextElement).css("top", topPx);
            });

            this.$el.html($ruler);

            this.$el.removeClass("hidden");
        },

        /**
         * The amount of pixels the CSS `top` property on the ruler marking label (the 100, 200, etc markers) needs to have.
         * @param {Number} index index of text element (`0` for the marker for 0px, `1` for the marker for 100px)
         * @param {Number} scaleFactor `1` for 100%, `0.67` for 67%
         * @return {Number} amount of pixels that the CSS `top` property should have marked on it to position it correctly.
         */
        _calculateIncrementTextElementTopPx: function(index, scaleFactor) {
            if (index === 0) {
                return -25;
            }

            if (scaleFactor === 0.25) {
                return -25;
            }

            return (scaleFactor * -2) - 22;
        },

        _onMouseDown: function(mouseDownEvent) {
            this.trigger("guideline:add", mouseDownEvent);
            return false;
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/ruler/VerticalRulerView.js